<template>
  <page-view class="page-invoice-search mwclg-style">
    <div slot="pageRight">
      <div class="order-search">
        <p class="title">{{ $t('InvoiceInquiry.InvoiceInquiry') }}</p>
        <div class="flex">
          <el-form
            ref="searchForm"
            :model="searchForm"
            style="flex: 1"
            :label-width="lang == 'zh' ? '100px' : '150px'"
          >
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item
                  :label="$t('InvoiceInquiry.InvoiceIssuingEntity')"
                >
                  <el-select
                    v-model="searchForm.officeCode"
                    clearable
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                  >
                    <el-option
                      v-for="item in accountList"
                      :key="item.officeCode"
                      :label="item.officeName"
                      :value="item.officeCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('InvoiceInquiry.InvoiceNumber')">
                  <el-input
                    v-model="searchForm.taxInvoiceNo"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item :label="$t('InvoiceInquiry.TypeOfBill')">
                  <el-select
                    v-model="searchForm.invType"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                  >
                    <el-option
                      v-for="item in Object.values(INVOICE_BASE)"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="8">
                <el-form-item :label="$t('InvoiceInquiry.InvoiceType')">
                  <el-select
                    v-model="searchForm.taxInvType"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                  >
                    <el-option
                      v-for="item in Object.values(INVOICE_TYPE)"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item :label="$t('InvoiceInquiry.PaymentDate')">
                  <el-date-picker
                    v-model="paymentDate"
                    type="daterange"
                    size="small"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="searchTimeChange"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('InvoiceInquiry.PaidOrNot')">
                  <el-select
                    v-model="searchForm.bpayed"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                  >
                    <el-option
                      v-for="item in [
                        { name: $t('InvoiceInquiry.All'), code: '' },
                        { name: $t('InvoiceInquiry.Yes'), code: '1' },
                        { name: $t('InvoiceInquiry.No'), code: '0' }
                      ]"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="产品编号MID">
                  <el-input
                    size="small"
                    v-model="searchForm.GoodsRemark"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="产品名称">
                  <el-input
                    size="small"
                    v-model="searchForm.GoodsNameCN"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Do">
                  <el-input
                    size="small"
                    v-model="searchForm.CustomerDNNo"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="车牌号">
                  <el-input
                    size="small"
                    v-model="searchForm.VehicleNo"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Shipto">
                  <el-input
                    size="small"
                    v-model="searchForm.TaskRemark"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              -->
            </el-row>
          </el-form>
          <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
          <div style="margin-top: 10px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              :loading="pageLoading"
              @click="search()"
              >{{ $t('InvoiceInquiry.Inquire') }}</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh-right"
              :loading="pageLoading"
              @click="reset()"
              >{{ $t('InvoiceInquiry.Reset') }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="order-list">
        <!-- <p class="title">发票列表</p> -->
        <el-button
          type="primary"
          size="small"
          style="margin-bottom: 6px"
          :loading="exportLoading"
          :disabled="pageLoading"
          @click="exportInvoiceList()"
          >{{ $t('InvoiceInquiry.ExportList') }}</el-button
        >
        <el-table
          v-loading="pageLoading"
          :data="tableData"
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="officeName"
            :label="$t('InvoiceInquiry.InvoiceIssuingEntity')"
            width="240"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="invHeadName"
            :label="$t('InvoiceInquiry.InvoiceTitle')"
            width="220"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="invType"
            :label="$t('InvoiceInquiry.InvoiceSettlementType')"
            :width="lang == 'zh' ? '100' : '180'"
          >
            <template #default="{ row }">
              <span>{{ row.invType | codeToName('INVOICE_BASE') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taxInvoiceNo"
            :label="$t('InvoiceInquiry.InvoiceNumber')"
            :width="lang == 'zh' ? '120' : '150'"
          >
            <template #default="{ row }">
              <span>{{ row.taxInvoiceNo }}</span>
              <!-- <el-button
                type="text"
                @click="
                  $router.push({
                    name: 'InvoiceDetail',
                    query: { invoiceNo: row.invoiceNo },
                  })
                "
                >{{ row.taxInvoiceNo }}</el-button
              > -->
            </template>
          </el-table-column>
          <el-table-column
            prop="taxInvoiceDate"
            :label="$t('InvoiceInquiry.InvoiceDate')"
            width="110"
          >
            <template #default="{ row }">
              <span>{{
                row.taxInvoiceDate
                  ? moment(row.taxInvoiceDate).format(DATE_FORMAT)
                  : ''
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taxInvType"
            :label="$t('InvoiceInquiry.InvoiceType')"
            :width="lang == 'zh' ? '80' : '120'"
          >
            <template #default="{ row }">
              <span>{{ row.taxInvType | codeToName('INVOICE_TYPE') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="paymentDays"
            :label="$t('InvoiceInquiry.BillingPeriod')"
            :width="lang == 'zh' ? '80' : '120'"
          ></el-table-column>
          <el-table-column
            :label="$t('InvoiceInquiry.InvoiceValue')"
            align="center"
          >
            <el-table-column
              prop="currType"
              :label="$t('InvoiceInquiry.CurrencyType')"
              :width="lang == 'zh' ? '60' : '120'"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="amount"
              :label="$t('InvoiceInquiry.AmountOfMoney')"
              :width="lang == 'zh' ? '100' : '150'"
              align="right"
            ></el-table-column>
          </el-table-column>
          <el-table-column
            :label="$t('InvoiceInquiry.ReceivableBalance')"
            align="center"
          >
            <el-table-column
              prop="currType"
              :label="$t('InvoiceInquiry.CurrencyType')"
              :width="lang == 'zh' ? '60' : '120'"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="balanceAmount"
              :label="$t('InvoiceInquiry.AmountOfMoney')"
              :width="lang == 'zh' ? '100' : '150'"
              align="right"
            ></el-table-column>
          </el-table-column>
          <el-table-column
            prop="payableDate"
            :label="$t('InvoiceInquiry.PaymentDate')"
            width="110"
          >
            <template #default="{ row }">
              <span>{{
                row.payableDate
                  ? moment(row.payableDate).format(DATE_FORMAT)
                  : ''
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="actualPayableDate"
            :label="$t('InvoiceInquiry.ActualPaymentDate')"
            :width="lang == 'zh' ? '110' : '160'"
          >
            <template #default="{ row }">
              <span>{{
                row.actualPayableDate
                  ? moment(row.actualPayableDate).format(DATE_FORMAT)
                  : ''
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="overdueDays"
            :label="$t('InvoiceInquiry.DaysOverdue')"
            :width="lang == 'zh' ? '100' : '150'"
          ></el-table-column>
          <el-table-column
            prop="bpayed"
            :label="$t('InvoiceInquiry.PaidOrNot')"
            width="100"
          >
            <template #default="{ row }">
              <span v-if="row.bpayed === '1'">{{
                $t('InvoiceInquiry.Yes')
              }}</span>
              <span v-else>{{ $t('InvoiceInquiry.No') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('InvoiceInquiry.Operate')"
            width="140"
            fixed="right"
            align="center"
          >
            <template #default="{ row }">
              <a
                v-if="row.etaxInvAddress"
                :href="row.etaxInvAddress"
                target="_blank"
                style="margin-right: 8px"
                >{{ $t('InvoiceInquiry.DownloadInvoice') }}</a
              >
              <el-button type="text" @click="openQuestionDialog(row)">{{
                $t('InvoiceInquiry.doubts')
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :visible.sync="questionDialogVisible"
          class="question-dialog"
          :title="$t('InvoiceInquiry.InvoiceDoubtsFeedback')"
          width="500px"
          center
          destroy-on-close
          @open="onQuestionDialogOpen"
          @closed="afterQuestionDialogClosed"
        >
          <el-form
            ref="feedbackForm"
            :model="feedbackForm"
            :rules="feedbackFormRules"
            style="flex: 1"
            label-width="150px"
          >
            <el-form-item
              :label="$t('InvoiceInquiry.FeedbackContent')"
              prop="queryContent"
            >
              <el-input
                v-model="feedbackForm.queryContent"
                size="small"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-form>
          <template #footer>
            <div>
              <el-button
                type="primary"
                :loading="feedbackLoading"
                size="medium"
                style="margin-right: 8px"
                @click="submitFeedbackForm"
                >{{ $t('ChangePassword.Submit') }}</el-button
              >
              <el-button
                :loading="feedbackLoading"
                size="medium"
                @click="questionDialogVisible = false"
                >{{ $t('ServiceEvaluation.Cancel') }}</el-button
              >
            </div>
          </template>
        </el-dialog>
        <!-- <div v-else style="text-align:center;padding:20px">暂无数据</div> -->
        <!-- <el-pagination
          v-show="tableData && tableData.length"
          style="text-align:right"
          background
          layout="prev, pager, next"
          :page-size="pageInfo.pageSize"
          :total="pageInfo.total"
          @current-change="currentPageChange"
        >
        </el-pagination> -->
        <div class="note-container">
          <h2 class="title">{{ $t('InvoiceInquiry.Instructions') }}</h2>
          <p>{{ $t('InvoiceInquiry.Instructions1') }}</p>
          <p>
            {{ $t('InvoiceInquiry.Instructions2') }}
          </p>
          <p>
            {{ $t('InvoiceInquiry.Instructions3') }}
          </p>
        </div>
      </div>
    </div>
  </page-view>
</template>
<script>
import { PageView } from "@/components";
import constants from "@/constants";
import {
  getInvoiceHeadList,
  insertInvoiceQuery,
  exportInvoiceHeadList,
} from "@/api/invoice";
import { HttpResponseCode } from "@/utils/request";
import moment from "moment";
import i18n from "@/i18n/i18n";
// import TableList from './modules/tableList'
// import { GetARByCusID } from '@/api/order'
// import { USER_INFO } from '@/store/mutation-types'
const YESTERDAY = moment().subtract(1, "day");
const lastDay = moment().startOf('months');
export default {
  name: "InvoiceSearch",
  components: { PageView },
  data() {
    return {
      moment,
      DATE_FORMAT: "YYYY-MM-DD",
      INVOICE_BASE: {
        ALL: { name: i18n.t("InvoiceInquiry.All"), code: "" },
        ...constants.INVOICE_BASE,
      },
      INVOICE_TYPE: {
        ALL: { name: i18n.t("InvoiceInquiry.All"), code: "" },
        ...constants.INVOICE_TYPE,
      },
      exportLoading: false,
      searchForm: {
        officeCode: "",
        invType: "",
        taxInvType: "",
        bpayed: "",
        payableDateBegin: "",
        payableDateEnd: "",
      },
      accountList: [],
      paymentDate: [lastDay, YESTERDAY],
      pageLoading: false,
      tableData: [],
      pageInfo: {
        pageSize: 10,
        page: 1,
        total: 11,
      },
      queryParams: {},
      orderTotal: {
        totalQty: 0,
        totalBaseQty: 0,
        totalNetWeight: 0,
        totalGrossWeight: 0,
      },
      jobType: "",
      userData: "",
      dataList: [],
      loading: false,
      questionDialogVisible: false,
      feedbackLoading: false,
      feedbackForm: {
        queryContent: "",
      },
      feedbackFormRules: {
        queryContent: [
          {
            required: true,
            message: i18n.t("InvoiceInquiry.PleaseEnterTheContent"),
          },
        ],
      },
      lang: "zh",
    };
  },
  created() {
    this.search();
    this.lang = this.$ls.get("lang");
  },
  methods: {
    async search() {
      this.pageLoading = true;
      const queryData = {
        ...this.searchForm,
        payableDateBegin: this.paymentDate[0]
          ? moment(this.paymentDate[0]).format("YYYY-MM-DD")
          : "",
        payableDateEnd: this.paymentDate[1]
          ? moment(this.paymentDate[1]).format("YYYY-MM-DD")
          : "",
      };
      await getInvoiceHeadList(queryData).then((res) => {
        if (res && res.code === HttpResponseCode.SUCCESS) {
          this.tableData = [...res.data];
          // const codeList = [...new Set(this.tableData.map(item => item.officeCode))]
          const officeEntries = {};

          this.tableData.forEach((item) => {
            officeEntries[item.officeCode] = {
              officeCode: item.officeCode,
              officeName: item.officeName,
            };
          });
          this.accountList = Object.values(officeEntries);
        }
      });
      this.pageLoading = false;
    },
    goSearch() { },
    reset() {
      this.paymentDate = [lastDay, YESTERDAY];
      this.searchForm = {
        officeCode: "",
        invType: "",
        taxInvType: "",
        bpayed: "",
        payableDateBegin: "",
        payableDateEnd: "",
      };
      this.search();
    },
    searchTimeChange(dateRange) {
      if (dateRange && dateRange.length && dateRange[0]) {
        this.searchForm.payableDateBegin = moment(dateRange[0]).format(
          "YYYY-MM-DD"
        );
        this.searchForm.payableDateEnd = moment(dateRange[1]).format(
          "YYYY-MM-DD"
        );
      } else {
        this.searchForm.payableDateBegin = "";
        this.searchForm.payableDateEnd = "";
      }
    },
    currentPageChange() { },
    downloadInvoice(invoiceId) {
      console.log(invoiceId);
    },
    openQuestionDialog(row) {
      this.feedbackForm = {
        queryContent: "",
        taxInvoiceNo: row.taxInvoiceNo,
      };
      this.questionDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.feedbackForm.clearValidate();
      });
    },
    onQuestionDialogOpen() { },
    async submitFeedbackForm() {
      this.$refs.feedbackForm.validate(async (valid) => {
        if (valid) {
          this.feedbackLoading = true;
          await insertInvoiceQuery({ ...this.feedbackForm }).then((res) => {
            if (res && res.code === HttpResponseCode.SUCCESS) {
              this.questionDialogVisible = false;
            }
          });
          this.feedbackLoading = false;
        }
      });
    },
    afterQuestionDialogClosed() {
      this.feedbackForm = {
        queryContent: "",
      };
    },
    async exportInvoiceList() {
      this.exportLoading = true;
      const queryData = {
        ...this.searchForm,
        payableDateBegin: this.paymentDate[0]
          ? moment(this.paymentDate[0]).format("YYYY-MM-DD")
          : "",
        payableDateEnd: this.paymentDate[1]
          ? moment(this.paymentDate[1]).format("YYYY-MM-DD")
          : "",
        language: this.lang == "zh" ? "ZN" : "EN",
      };
      await exportInvoiceHeadList(queryData);
      this.exportLoading = false;
    },
    // search () {
    //   const userInfo = this.$ls.get(USER_INFO)
    //   this.queryParams.CustomerId = userInfo.CACode
    //   this.loading = true
    //   GetARByCusID(this.queryParams).then(res => {
    //     this.dataList = res.Data.CbList || []
    //     this.loading = false
    //   }).catch(() => {
    //     this.loading = false
    //   })
    // },
    // reset () {
    //   this.queryParams = {}
    //   this.search()
    // }
  },
};
</script>
<style lang="less">
.page-invoice-search {
  padding: 10px;
  background: #f0f6fb;
  // .plr25 {
  //   padding-left: 0px !important;
  //   padding-right: 0px !important;
  // }
  // .ptb25 {
  //   padding-top: 0px !important;
  //   padding-bottom: 0px !important;
  // }
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    min-height: 60vh;
    .list-item {
      margin-bottom: 8px;
    }
  }
  .note-container {
    margin-top: 14px;
    line-height: 20px;
    .title {
      margin-bottom: 2px;
    }
  }
  .el-col.el-col-8 {
    padding: 0 !important;
  }
  // .header_icon {
  //   width: 34px;
  //   height: 34px;
  //   display: inline-block;
  // }
  // .order-no {
  //   font-size: 16px;
  //   font-weight: 400;
  //   color: #111827;
  //   margin-left: 18px;
  //   display: inline-block;
  // }
  // .order-head-infomation {
  //   padding-left: 52px;
  //   display: flex;
  //   justify-content: flex;
  // }
  // .detail-info {
  //   border-radius: 10px;
  //   // border: 1px solid #e9ecf2;
  //   padding: 16px 0;
  //   display: flex;
  //   justify-content: flex-start;
  //   background: #F6F6F8;
  //   .detail-info-status {
  //     background: #59b9d3;
  //     width: 3px;
  //     margin-left: -1px;
  //     border-radius: 0 16px 16px 0;
  //   }
  //   .detail-info-content {
  //     flex: 1;
  //     margin-left: 20px;
  //   }
  //   .track-btn {
  //     width: 107px;
  //     height: 28px;
  //     background: #59b9d3;
  //     border-radius: 4px;
  //     margin: 45px 23px;
  //     line-height: 8px;
  //   }
  // }
}
</style>
